
import Vue from 'vue';
import lodash from 'lodash';
import * as moment from 'moment';
import 'moment/locale/zh-cn';
import { monthNames, dayNames, dayNamesShort } from '@/util/dateUtils';

export const createPicker = (app, inputEl, values, displayValues, model, propKey) => {
  const pickerComp = app.$f7.picker.create({
    inputEl,
    toolbarCloseText: '确定',
    routableModals: false,
    cols: [
      {
        textAlign: 'center',
        values,
        displayValues,
      },
    ],
    formatValue: (vals, disVals) => disVals[0],
    on: {
      change(picker, vals) {
        Vue.set(app[model], propKey, vals[0]);
      },
    },
  });
  if (!lodash.isEmpty(app[model]) && !lodash.isEmpty(app[model][propKey])) {
    pickerComp.setValue([app[model][propKey]]);
  }
  return pickerComp;
};

export const createPickerTime = (app, inputEl, model, propKey) => {
  const today = new Date();
  const pickerTimeComp = app.$f7.picker.create({
    inputEl,
    toolbarCloseText: '确定',
    routableModals: false,
    value: [
      `${today.getFullYear()}`,
      today.getMonth() < 9 ? `0${today.getMonth() + 1}` : `${today.getMonth() + 1}`,
      today.getDate() < 10 ? `0${today.getDate()}` : `${today.getDate()}`,
      today.getHours() < 10 ? `0${today.getHours()}` : `${today.getHours()}`,
      today.getMinutes() < 10 ? `0${today.getMinutes()}` : `${today.getMinutes()}`,
    ],
    formatValue: values => `${values[0]}-${values[1]}-${values[2]} ${values[3]}:${values[4]}`,
    cols: [
      {
        textAlign: 'center',
        values: (() => {
          const arr = [];
          for (let i = 1972; i <= 2200; i += 1) {
            arr.push(`${i}`);
          }
          return arr;
        })(),
      }, {
        textAlign: 'center',
        values: (() => {
          const arr = [];
          for (let i = 1; i <= 12; i += 1) {
            arr.push(i < 10 ? `0${i}` : `${i}`);
          }
          return arr;
        })(),
      }, {
        textAlign: 'center',
        values: (() => {
          const arr = [];
          for (let i = 1; i <= 31; i += 1) {
            arr.push(i < 10 ? `0${i}` : `${i}`);
          }
          return arr;
        })(),
      }, {
        textAlign: 'center',
        values: (() => {
          const arr = [];
          for (let i = 0; i <= 23; i += 1) {
            arr.push(i < 10 ? `0${i}` : `${i}`);
          }
          return arr;
        })(),
      }, {
        textAlign: 'center',
        values: (() => {
          const arr = [];
          for (let i = 0; i <= 59; i += 1) {
            arr.push(i < 10 ? `0${i}` : `${i}`);
          }
          return arr;
        })(),
      },
    ],
    on: {
      change(picker, values) {
        Vue.set(app[model], propKey, `${values[0]}-${values[1]}-${values[2]} ${values[3]}:${values[4]}:00`);
      },
    },
  });
  return pickerTimeComp;
};

export const createCalendar = (app, inputEl, model, propKey, events = []) => {
  const calComp = app.$f7.calendar.create({
    inputEl,
    monthNames,
    dayNames,
    dayNamesShort,
    events,
    dateFormat: 'yyyy-mm-dd',
    closeOnSelect: true,
    routableModals: false,
    on: {
      change(calendar, values) {
        Vue.set(app[model], propKey, moment(values[0]).format('YYYY-MM-DD'));
      },
    },
  });
  if (!lodash.isEmpty(app[model])
    && (!lodash.isEmpty(app[model][propKey]) || lodash.isNumber(app[model][propKey]))) {
    calComp.setValue([moment(app[model][propKey]).toDate()]);
  }
  return calComp;
};

export const createToast = (app, msg) => {
  const toastComp = app.$f7.toast.create({
    destroyOnClose: true,
    text: msg,
    position: 'center',
    closeTimeout: 3000,
  }).open();
  return toastComp;
};



// WEBPACK FOOTER //
// ./src/util/compUtils.js